import React, { useEffect, useState } from 'react';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';

const Client = ({ _id }) => {
  const [client, setClient] = useState({});

  useEffect(() => {
    fetch(process.env.REACT_APP_PROXY_HOST + '/gere/client/' + _id, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => setClient(data));
  }, [_id]);

  return <div>{client.Nom} <PhoneAndroidIcon />{client.Appareils === undefined ? 0 : client.Appareils.length}</div>;
};

export default Client;



// WEBPACK FOOTER //
// src/components/clients/Client.js